export const isEmptyObject = (object: any) => {
  return !object || !(Object.keys(object).length > 0)
}

export const debounce = (func: (...args: any[])=>void) => {
  let timeout: NodeJS.Timeout;
  return (...args: any[]) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, 1000);
  };
};

export function maskingName(name?: string, shouldMask?: boolean) {
  if (!!name && shouldMask) {
    const length = name.length;
    let mask = "";
    for (let i = 0; length > 0 && i < length - 2; i++) mask += "*";
    if (length === 2) name = name.substring(0, 1) + "*";
    else if (length > 2)
      name = name.substring(0, 1) + mask + name.substring(length - 1);
  }
  return name;
}
